import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CancelReasonsService } from 'src/app/services/core/cancelReason/cancel-reasons.service';
import { RoleService } from 'src/app/services/core/role/role.service';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()

@Component({
  selector: 'app-add-cancel-reason',
  templateUrl: './add-cancel-reason.component.html',
  styleUrls: ['./add-cancel-reason.component.css']
})
export class AddCancelReasonComponent {
  
  addCancelReasonForm!: FormGroup;
  cancelReasonId: any;
  submitted = false;
  selecteType = [];
  types: any;


  // Edit Modal Inputs and Outputs
  @Input() changeReasons: any;
  @Input() source: any;
  @Output() onSaveChangeReasons = new EventEmitter<string>();
  @Output() onCloseModal = new EventEmitter<string>();
  // Edit Modal Inputs and Outputs End

  constructor(private fb: FormBuilder, private route: ActivatedRoute, private router: Router, private cancelReasonsService: CancelReasonsService, private roleService: RoleService) {

  }

  ngOnInit() {
    this.getAllTypes();
    this.initForm()
    if (this.source === 'modal' && this.changeReasons) {
      this.cancelReasonId = this.changeReasons.id;
      this.getCancelReasonById();
    } else {

      this.cancelReasonId = this.route.snapshot.params['change-reasons'];
      if (this.cancelReasonId) {
        this.getCancelReasonById();
      }
    }


  }
  initForm() {
    this.addCancelReasonForm = this.fb.group({
      title: ['', Validators.required],
      description: ['', Validators.required],
      isActive: [true, Validators.required],
      audience: ['', Validators.required],
      isBillable: [false],
      isNoShow: [false],
    })
  }

  onSave() {
    this.submitted = true;

    this.addCancelReasonForm.patchValue({
      audience: this.selecteType,
    });

    if (this.addCancelReasonForm.invalid)
      return;


    const payload = this.addCancelReasonForm.value;

    this.cancelReasonsService.save(this.cancelReasonId, payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        if (this.source === 'modal') {
          this.onSaveChangeReasons.emit(data);
        } else {
          this.router.navigateByUrl('configurations/change-reasons');

        }
      }
    },
      (err) => {
        sweetAlert("Error", err, "error", "OK");
      }
  )
  }

  get form(){
    return this.addCancelReasonForm.controls;
  }

  getCancelReasonById() {
    this.cancelReasonsService.getById(this.cancelReasonId)
      .pipe(untilDestroyed(this))
      .subscribe(
        (data: any) => {
          if (data) {
            this.addCancelReasonForm.patchValue(data);
            this.selecteType = data.audience;
          }
        },
        (err: any) => {
          sweetAlert('Error', err, 'error', 'OK');
        }
      );

  }

  getAllTypes() {
    this.roleService.getTypes().pipe(untilDestroyed(this)).subscribe(
      (data: any) => {
        if (data) {
          this.types = data.map((item: string) => ({
            value: item,
            label: item === 'fundingsource' ? 'Health' : item.charAt(0).toUpperCase() + item.slice(1)
          }));
        }
      },
      (err) => {
        const errorMessage = err || 'An unexpected error occurred.';
        sweetAlert('Error', errorMessage, 'warning', 'OK');
      }

    );
  }

  //   toggleAutoInvoice(event: Event) {
  //   const isChecked = (event.target as HTMLInputElement).checked;
  //   this.addCancelReasonForm.patchValue({
  //     quickbooks:{
  //       isBillable: isChecked
  //     }
  //   });
  // }
}
